let _currentLanguage = "";
let _fallbackLanguage = "";
let _languages: string[] = [];
let _translations = {};

export const getCurrentLanguage = (): string => {
  return _currentLanguage;
};

export const setCurrentLanguage = (currentLanguage: string): void => {
  _currentLanguage = currentLanguage;
};

export const getFallbackLanguage = (): string => {
  return _fallbackLanguage;
};

export const setFallbackLanguage = (fallbackLanguage: string): void => {
  _fallbackLanguage = fallbackLanguage;
};

export const getLanguages = (): string[] => {
  return _languages;
};

export const getFlags = (): { [name: string]: string } => {
  const flagMapLanguages = {
    en: "gb",
    it: "it",
    fr: "fr",
    es: "es"
  };
  const availableFlags = {};

  Object.keys(flagMapLanguages).forEach(key => {
    if (_languages.indexOf(key) !== -1) {
      availableFlags[key] = flagMapLanguages[key];
    }
  });

  return availableFlags;
};

export const setLanguages = (languages: string[]): void => {
  _languages = languages;

  _languages.forEach(async language => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const loadedLanguage = require(`../Languages/${language}.json`);
    _translations[language] = loadedLanguage;
  });
};

export const getTranslations = (): { [name: string]: string } => {
  return _translations;
};

export const setTranslations = (
  translations: Record<string, unknown>
): void => {
  _translations = translations;
};

const addParamsToLabel = (
  label: string,
  params: { [x: string]: string }
): string => {
  const finalLabel: string[] = [];
  const splittedLabel = label.split("${");

  if (splittedLabel.length > 1) {
    splittedLabel.forEach((element: string) => {
      const parmsSplitted = element.split("}");
      if (parmsSplitted.length > 1) {
        finalLabel.push(params[parmsSplitted[0]]);
        finalLabel.push(parmsSplitted[1]);
      } else {
        finalLabel.push(parmsSplitted[0]);
      }
    });
  } else {
    finalLabel.concat(splittedLabel);
  }

  return finalLabel.join("");
};

export const t = (
  label: string | number,
  params: { [x: string]: string }
): string => {
  let labelTranslated =
    _translations[_currentLanguage] && _translations[_currentLanguage][label]
      ? _translations[_currentLanguage][label]
      : _translations[_fallbackLanguage] &&
        _translations[_fallbackLanguage][label]
        ? _translations[_fallbackLanguage][label]
        : label;

  if (params) {
    labelTranslated = addParamsToLabel(labelTranslated, params);
  }

  return labelTranslated;
};
